import { useContext, useMemo } from "react";
import { BulkTargetingWizardContext } from "@app/targeting/import/TargetingWizardContext";
import { BulkCreateProviderTargetingModel } from "@app/targeting/import/interfaces";

export const useBulkTargetingModel = (): BulkCreateProviderTargetingModel => {
  const context = useContext(BulkTargetingWizardContext);
  const model = useMemo<BulkCreateProviderTargetingModel>(() => {
  return {
    bulkTargetId: context.bulkProviderTargetId,
    columnConfigurations: context.columnConfigurations,
    customProjectIds: context.eligibleSelectedProjectIds.map((id) => parseInt(id, 10)),
    emailOnSuccess: context.emailOnSuccess,
    existingTargetAction: context.existingTargetAction,
    exportName: context.filename,
    formatType: context.formatType,
    isDistinctServicingProviderReport: context.isDistinctServicingProviderReport,
    projectType: context.projectType,
    reasonDescription: context.comment,
    reasonName: context.targetingReason,
    selectedReports: context.selectedReports,
  };
  }, [
    context.bulkProviderTargetId,
    context.columnConfigurations,
    context.eligibleSelectedProjectIds,
    context.emailOnSuccess,
    context.existingTargetAction,
    context.filename,
    context.formatType,
    context.isDistinctServicingProviderReport,
    context.projectType,
    context.comment,
    context.targetingReason,
    context.selectedReports,
  ]);
return model;
};